import { size } from "lib/theme/size";
import { SxObjType } from "lib/theme/types/SxObjType.type";
import theme from "lib/theme/theme";

const sxStyles = () => {
  const borderColor = theme.palette.secondary.light;

  return {
    layout: {
      width: "100%",
      marginTop: theme.spacing(1),
    },
    listItem: {
      padding: theme.spacing(0.1, 2),
      marginRight: 0,
      borderBottom: `1px solid ${borderColor}`,
      "& .MuiRadio-colorPrimary.Mui-checked": {
        color: theme.palette.primary.main,
      },
      "& .MuiFormControlLabel-label": {
        color: theme.palette.grey[400],
        fontSize: size.FONTSIZE_14,
      },
    },

    radio: {
      color: theme.palette.primary.main,
      "& .MuiSvgIcon-root": {
        fontSize: size.FONTSIZE_24,
      },
    },
    text: {
      color: theme.palette.text.secondary,
      lineHeight: 1.5,
      padding: theme.spacing(2),
    },
    btnLink: {
      color: theme.palette.primary.main,
      typography: "body1_semibold",
    },
  } satisfies SxObjType;
};

export { sxStyles };
